import { render } from "./ShowRAB.vue?vue&type=template&id=0cc68f69"
import script from "./ShowRAB.vue?vue&type=script&lang=js"
export * from "./ShowRAB.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__